import { Layout } from 'components/Layout'
import React from 'react'
import styled, { keyframes } from 'styled-components'
import { getToken as token } from 'theming'

const loading = keyframes`  
    from {
        width: 0
    }
    to {
        width: 100%
    } 
`

export const Bar = styled.div<{ width?: number; velocity?: number }>`
  position: relative;

  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${token('space-s')};
  overflow: hidden;

  background-color: ${token('color-neutral-light')};
  border-radius: ${token('border-radius-m')};

  &:before {
    position: absolute;

    display: block;
    width: 100%;
    height: ${token('space-s')};

    background-color: ${token('color-primary')};

    animation: ${loading} ${({ velocity }) => (velocity && velocity > 0 ? velocity : 2.5)}s linear
      infinite;

    content: '';
  }
`

export interface LoadingBarProps {
  alignment?: 'left' | 'center' | 'right'
  title?: React.ReactNode
  secondaryTitle?: React.ReactNode
  width?: number | undefined
  velocity?: number | undefined
}

export default function LoadingBar({
  alignment,
  title,
  secondaryTitle,
  width = undefined,
  velocity = 2.5,
}: LoadingBarProps): JSX.Element {
  return (
    <Layout.Box textAlign={alignment}>
      <Layout.Stack space="s">
        {title}
        <Bar width={width} velocity={velocity} />
        {secondaryTitle}
      </Layout.Stack>
    </Layout.Box>
  )
}
